export default __webpack_public_path__ + "static/media/SupervityBlackIcon.348a886d.gif";